import { render, staticRenderFns } from "./InternalPromosExpiringInAMonth.vue?vue&type=template&id=316e6557"
import script from "./InternalPromosExpiringInAMonth.vue?vue&type=script&lang=js"
export * from "./InternalPromosExpiringInAMonth.vue?vue&type=script&lang=js"
import style0 from "./InternalPromosExpiringInAMonth.vue?vue&type=style&index=0&id=316e6557&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports